"use client";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRouter } from "next/navigation";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";
import StarRating from "@/custom/StarRating";
import { Filter } from "lucide-react";

const Filters = ({ brands }) => {
  const router = useRouter();
  let queryParams;

  const reset = (name) => {
    if (typeof window !== "undefined") {
      queryParams = new URLSearchParams(window.location.search);
    }

    if (queryParams.has(name)) {
      queryParams.delete(name);
      const newUrl = window.location.pathname + "?" + queryParams.toString();
      router.push(newUrl);

      const checkboxes = document.getElementsByName(name);
      checkboxes.forEach((item) => {
        if (item !== name) item.checked = false;
      });
    }
  };

  function handleClick(checkbox) {
    if (typeof window !== "undefined") {
      queryParams = new URLSearchParams(window.location.search);
    }
    const checkboxes = document.getElementsByName(checkbox.name);

    checkboxes.forEach((item) => {
      if (item !== checkbox) item.checked = false;
    });
    if (checkbox.checked === false) {
      queryParams.delete(checkbox.name);
    } else {
      if (queryParams.has(checkbox.name)) {
        queryParams.set(checkbox.name, checkbox.value);
      } else {
        queryParams.append(checkbox.name, checkbox.value);
      }
    }
    const path = window.location.pathname + "?" + queryParams.toString();
    router.push(path);
  }

  function checkHandler(checkBoxType, checkBoxValue) {
    if (typeof window !== "undefined") {
      queryParams = new URLSearchParams(window.location.search);

      const value = queryParams.get(checkBoxType);
      if (checkBoxValue === value) return true;
      return false;
    }
  }

  return (
    <>
      <div className="lg:hidden">
        <Sheet>
          <SheetTrigger className="border flex rounded items-center gap-2 p-2 text-custom-black  font-medium">
            Filters: <Filter size={20} />
          </SheetTrigger>
          <SheetContent>
            <SheetHeader>
              <SheetTitle className="text-base text-custom-black ">
                REFINE YOUR RESULTS
              </SheetTitle>
            </SheetHeader>
            <Accordion type="multiple" collapsible className="w-full">
              <AccordionItem value="Sort">
                <AccordionTrigger className="font-medium text-sm uppercase">
                  Sort By
                </AccordionTrigger>
                <AccordionContent>
                  <div className="max-h-64 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100 overflow-y-auto text-custom-black  text-sm">
                    <ul className="space-y-4">
                      <li>
                        <label className="flex items-center">
                          <input
                            name="sort"
                            type="checkbox"
                            value="price"
                            className="h-4 w-4"
                            defaultChecked={checkHandler("sort", "price")}
                            onClick={(e) => handleClick(e.target)}
                          />
                          <span className="ml-2 cursor-pointer text-custom-black   capitalize">
                            {" "}
                            Price Low to High{" "}
                          </span>
                        </label>
                      </li>
                      <li>
                        <label className="flex items-center">
                          <input
                            name="sort"
                            type="checkbox"
                            value="-price"
                            className="h-4 w-4"
                            defaultChecked={checkHandler("sort", "-price")}
                            onClick={(e) => handleClick(e.target)}
                          />
                          <span className="ml-2 cursor-pointer text-custom-black   capitalize">
                            {" "}
                            Price High to Low{" "}
                          </span>
                        </label>
                      </li>
                      <li>
                        <label className="flex items-center">
                          <input
                            name="sort"
                            type="checkbox"
                            value="-createdAt"
                            className="h-4 w-4"
                            defaultChecked={checkHandler("sort", "-createdAt")}
                            onClick={(e) => handleClick(e.target)}
                          />
                          <span className="ml-2 cursor-pointer text-custom-black   capitalize">
                            {" "}
                            Recently Published{" "}
                          </span>
                        </label>
                      </li>
                      <li>
                        <label className="flex items-center">
                          <input
                            name="sort"
                            type="checkbox"
                            value="-rating"
                            className="h-4 w-4"
                            defaultChecked={checkHandler("sort", "-rating")}
                            onClick={(e) => handleClick(e.target)}
                          />
                          <span className="ml-2 cursor-pointer text-custom-black   capitalize">
                            {" "}
                            Top Rating{" "}
                          </span>
                        </label>
                      </li>
                      <li>
                        <label className="flex items-center">
                          <input
                            name="sort"
                            type="checkbox"
                            value="rating"
                            className="h-4 w-4"
                            defaultChecked={checkHandler("sort", "rating")}
                            onClick={(e) => handleClick(e.target)}
                          />
                          <span className="ml-2 cursor-pointer text-custom-black   capitalize">
                            {" "}
                            Low Rating{" "}
                          </span>
                        </label>
                      </li>
                    </ul>
                    <div className="m-4">
                      <Button
                        variant="outline"
                        className="w-full"
                        onClick={() => reset("sort")}
                      >
                        Reset
                      </Button>
                    </div>
                  </div>
                </AccordionContent>
              </AccordionItem>
              <AccordionItem value="brands">
                <AccordionTrigger className="font-medium text-sm uppercase">
                  brands
                </AccordionTrigger>
                <AccordionContent>
                  <div className="max-h-64 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100 overflow-y-auto text-custom-black  text-sm">
                    <ul className="space-y-4">
                      {brands?.map((x, i) => (
                        <li key={i}>
                          <label className="flex items-center">
                            <input
                              name="brand"
                              type="checkbox"
                              value={x}
                              className="h-4 w-4"
                              defaultChecked={checkHandler("brand", x)}
                              onClick={(e) => handleClick(e.target)}
                            />
                            <span className="ml-2 cursor-pointer text-custom-black  capitalize">
                              {" "}
                              {x}{" "}
                            </span>
                          </label>
                        </li>
                      ))}
                    </ul>
                    <div className="m-4">
                      <Button
                        variant="outline"
                        className="w-full"
                        onClick={() => reset("brand")}
                      >
                        Reset
                      </Button>
                    </div>
                  </div>
                </AccordionContent>
              </AccordionItem>

              <AccordionItem value="Price">
                <AccordionTrigger className="font-medium text-sm uppercase">
                  Prices
                </AccordionTrigger>
                <AccordionContent>
                  <ul className="space-y-2">
                    <li>
                      <label className="flex items-center">
                        <input
                          name="price"
                          type="checkbox"
                          value="0-100"
                          className="h-4 w-4"
                          defaultChecked={checkHandler("price", "0-100")}
                          onClick={(e) => handleClick(e.target)}
                        />
                        <span className="ml-2 cursor-pointer text-custom-black   capitalize">
                          Under BDT 100
                        </span>
                      </label>
                    </li>
                    <li>
                      <label className="flex items-center">
                        <input
                          name="price"
                          type="checkbox"
                          value="100-300"
                          className="h-4 w-4"
                          defaultChecked={checkHandler("price", "100-300")}
                          onClick={(e) => handleClick(e.target)}
                        />
                        <span className="ml-2 cursor-pointer text-custom-black   capitalize">
                          BDT 100-300
                        </span>
                      </label>
                    </li>
                    <li>
                      <label className="flex items-center">
                        <input
                          name="price"
                          type="checkbox"
                          value="300-500"
                          className="h-4 w-4"
                          defaultChecked={checkHandler("price", "300-500")}
                          onClick={(e) => handleClick(e.target)}
                        />
                        <span className="ml-2 cursor-pointer text-custom-black   capitalize">
                          BDT 300-500
                        </span>
                      </label>
                    </li>
                    <li>
                      <label className="flex items-center">
                        <input
                          name="price"
                          type="checkbox"
                          value="500-1000"
                          className="h-4 w-4"
                          defaultChecked={checkHandler("price", "500-1000")}
                          onClick={(e) => handleClick(e.target)}
                        />
                        <span className="ml-2 cursor-pointer text-custom-black   capitalize">
                          BDT 500-1000
                        </span>
                      </label>
                    </li>
                    <li>
                      <label className="flex items-center">
                        <input
                          type="checkbox"
                          className="h-4 w-4"
                          name="price"
                          value="1000-1000000"
                          defaultChecked={checkHandler("price", "1000-1000000")}
                          onClick={(e) => handleClick(e.target)}
                        />
                        <span className="ml-2 cursor-pointer text-custom-black   capitalize">
                          Above BDT 1000
                        </span>
                      </label>
                    </li>
                  </ul>
                  <div className="m-4">
                    <Button
                      variant="outline"
                      className="w-full"
                      onClick={() => reset("price")}
                    >
                      Reset
                    </Button>
                  </div>
                </AccordionContent>
              </AccordionItem>
              <AccordionItem value="rating">
                <AccordionTrigger className="font-medium text-sm uppercase">
                  Ratings
                </AccordionTrigger>
                <AccordionContent>
                  <ul className="space-y-2">
                    <li>
                      <label className="flex items-center gap-2 cursor-pointer">
                        <input
                          name="rating"
                          type="checkbox"
                          value="5"
                          className="h-4 w-4"
                          defaultChecked={checkHandler("rating", "5")}
                          onClick={(e) => handleClick(e.target)}
                        />
                        <StarRating rate={5} size={18} />
                      </label>
                    </li>
                    <li>
                      <label className="flex items-center gap-2 cursor-pointer">
                        <input
                          name="rating"
                          type="checkbox"
                          value="4"
                          className="h-4 w-4"
                          defaultChecked={checkHandler("rating", "4")}
                          onClick={(e) => handleClick(e.target)}
                        />
                        <StarRating rate={4} size={18} />
                      </label>
                    </li>
                    <li>
                      <label className="flex items-center gap-2 cursor-pointer">
                        <input
                          name="rating"
                          type="checkbox"
                          value="3"
                          className="h-4 w-4"
                          defaultChecked={checkHandler("rating", "3")}
                          onClick={(e) => handleClick(e.target)}
                        />
                        <StarRating rate={3} size={18} />
                      </label>
                    </li>
                    <li>
                      <label className="flex items-center gap-2 cursor-pointer">
                        <input
                          name="rating"
                          type="checkbox"
                          value="2"
                          className="h-4 w-4"
                          defaultChecked={checkHandler("rating", "2")}
                          onClick={(e) => handleClick(e.target)}
                        />
                        <StarRating rate={2} size={18} />
                      </label>
                    </li>
                    <li>
                      <label className="flex items-center gap-2 cursor-pointer">
                        <input
                          type="checkbox"
                          className="h-4 w-4"
                          name="rating"
                          value="1"
                          defaultChecked={checkHandler("rating", "1")}
                          onClick={(e) => handleClick(e.target)}
                        />
                        <StarRating rate={1} size={18} />
                      </label>
                    </li>
                  </ul>
                  <div className="m-4">
                    <Button
                      variant="outline"
                      className="w-full"
                      onClick={() => reset("rating")}
                    >
                      Reset
                    </Button>
                  </div>
                </AccordionContent>
              </AccordionItem>
            </Accordion>
          </SheetContent>
        </Sheet>
      </div>
      <Card className="hidden lg:flex w-56 min-w-[224px] flex-col">
        <CardHeader className="bg-custom-slider-bg-gray ">
          <CardTitle className="text-base text-custom-black ">
            REFINE YOUR RESULTS
          </CardTitle>
        </CardHeader>
        <CardContent className="flex flex-col gap-2 px-4">
          <Accordion type="multiple" collapsible className="w-full">
            <AccordionItem value="Sort">
              <AccordionTrigger className="font-medium text-sm uppercase">
                Sort By
              </AccordionTrigger>
              <AccordionContent>
                <div className="max-h-64 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100 overflow-y-auto text-custom-black  text-sm">
                  <ul className="space-y-4">
                    <li>
                      <label className="flex items-center">
                        <input
                          name="sort"
                          type="checkbox"
                          value="price"
                          className="h-4 w-4"
                          defaultChecked={checkHandler("sort", "price")}
                          onClick={(e) => handleClick(e.target)}
                        />
                        <span className="ml-2 cursor-pointer text-custom-black   capitalize">
                          {" "}
                          Price Low to High{" "}
                        </span>
                      </label>
                    </li>
                    <li>
                      <label className="flex items-center">
                        <input
                          name="sort"
                          type="checkbox"
                          value="-price"
                          className="h-4 w-4"
                          defaultChecked={checkHandler("sort", "-price")}
                          onClick={(e) => handleClick(e.target)}
                        />
                        <span className="ml-2 cursor-pointer text-custom-black   capitalize">
                          {" "}
                          Price High to Low{" "}
                        </span>
                      </label>
                    </li>
                    <li>
                      <label className="flex items-center">
                        <input
                          name="sort"
                          type="checkbox"
                          value="-createdAt"
                          className="h-4 w-4"
                          defaultChecked={checkHandler("sort", "-createdAt")}
                          onClick={(e) => handleClick(e.target)}
                        />
                        <span className="ml-2 cursor-pointer text-custom-black   capitalize">
                          {" "}
                          Recently Published{" "}
                        </span>
                      </label>
                    </li>
                    <li>
                      <label className="flex items-center">
                        <input
                          name="sort"
                          type="checkbox"
                          value="-rating"
                          className="h-4 w-4"
                          defaultChecked={checkHandler("sort", "-rating")}
                          onClick={(e) => handleClick(e.target)}
                        />
                        <span className="ml-2 cursor-pointer text-custom-black   capitalize">
                          {" "}
                          Top Rating{" "}
                        </span>
                      </label>
                    </li>
                    <li>
                      <label className="flex items-center">
                        <input
                          name="sort"
                          type="checkbox"
                          value="rating"
                          className="h-4 w-4"
                          defaultChecked={checkHandler("sort", "rating")}
                          onClick={(e) => handleClick(e.target)}
                        />
                        <span className="ml-2 cursor-pointer text-custom-black   capitalize">
                          {" "}
                          Low Rating{" "}
                        </span>
                      </label>
                    </li>
                  </ul>
                  <div className="m-4">
                    <Button
                      variant="outline"
                      className="w-full"
                      onClick={() => reset("sort")}
                    >
                      Reset
                    </Button>
                  </div>
                </div>
              </AccordionContent>
            </AccordionItem>
            <AccordionItem value="brands">
              <AccordionTrigger className="font-medium text-sm uppercase">
                brands
              </AccordionTrigger>
              <AccordionContent>
                <div className="max-h-64 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100 overflow-y-auto text-custom-black  text-sm">
                  <ul className="space-y-4">
                    {brands?.map((x, i) => (
                      <li key={i}>
                        <label className="flex items-center">
                          <input
                            name="brand"
                            type="checkbox"
                            value={x}
                            className="h-4 w-4"
                            defaultChecked={checkHandler("brand", x)}
                            onClick={(e) => handleClick(e.target)}
                          />
                          <span className="ml-2 cursor-pointer text-custom-black  capitalize">
                            {" "}
                            {x}{" "}
                          </span>
                        </label>
                      </li>
                    ))}
                  </ul>
                  <div className="m-4">
                    <Button
                      variant="outline"
                      className="w-full"
                      onClick={() => reset("brand")}
                    >
                      Reset
                    </Button>
                  </div>
                </div>
              </AccordionContent>
            </AccordionItem>
            <AccordionItem value="Price">
              <AccordionTrigger className="font-medium text-sm uppercase">
                Prices
              </AccordionTrigger>
              <AccordionContent>
                <ul className="space-y-2">
                  <li>
                    <label className="flex items-center">
                      <input
                        name="price"
                        type="checkbox"
                        value="0-100"
                        className="h-4 w-4"
                        defaultChecked={checkHandler("price", "0-100")}
                        onClick={(e) => handleClick(e.target)}
                      />
                      <span className="ml-2 cursor-pointer text-custom-black   capitalize">
                        Under BDT 100
                      </span>
                    </label>
                  </li>
                  <li>
                    <label className="flex items-center">
                      <input
                        name="price"
                        type="checkbox"
                        value="100-300"
                        className="h-4 w-4"
                        defaultChecked={checkHandler("price", "100-300")}
                        onClick={(e) => handleClick(e.target)}
                      />
                      <span className="ml-2 cursor-pointer text-custom-black   capitalize">
                        BDT 100-300
                      </span>
                    </label>
                  </li>
                  <li>
                    <label className="flex items-center">
                      <input
                        name="price"
                        type="checkbox"
                        value="300-500"
                        className="h-4 w-4"
                        defaultChecked={checkHandler("price", "300-500")}
                        onClick={(e) => handleClick(e.target)}
                      />
                      <span className="ml-2 cursor-pointer text-custom-black   capitalize">
                        BDT 300-500
                      </span>
                    </label>
                  </li>
                  <li>
                    <label className="flex items-center">
                      <input
                        name="price"
                        type="checkbox"
                        value="500-1000"
                        className="h-4 w-4"
                        defaultChecked={checkHandler("price", "500-1000")}
                        onClick={(e) => handleClick(e.target)}
                      />
                      <span className="ml-2 cursor-pointer text-custom-black   capitalize">
                        BDT 500-1000
                      </span>
                    </label>
                  </li>
                  <li>
                    <label className="flex items-center">
                      <input
                        type="checkbox"
                        className="h-4 w-4"
                        name="price"
                        value="1000-10000"
                        defaultChecked={checkHandler("price", "1000-10000")}
                        onClick={(e) => handleClick(e.target)}
                      />
                      <span className="ml-2 cursor-pointer text-custom-black   capitalize">
                        Above BDT 1000
                      </span>
                    </label>
                  </li>
                </ul>
                <div className="m-4">
                  <Button
                    variant="outline"
                    className="w-full"
                    onClick={() => reset("price")}
                  >
                    Reset
                  </Button>
                </div>
              </AccordionContent>
            </AccordionItem>
            <AccordionItem value="rating">
              <AccordionTrigger className="font-medium text-sm uppercase">
                Ratings
              </AccordionTrigger>
              <AccordionContent>
                <ul className="space-y-2">
                  <li>
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input
                        name="rating"
                        type="checkbox"
                        value="5"
                        className="h-4 w-4"
                        defaultChecked={checkHandler("rating", "5")}
                        onClick={(e) => handleClick(e.target)}
                      />
                      <StarRating rate={5} size={18} />
                    </label>
                  </li>
                  <li>
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input
                        name="rating"
                        type="checkbox"
                        value="4"
                        className="h-4 w-4"
                        defaultChecked={checkHandler("rating", "4")}
                        onClick={(e) => handleClick(e.target)}
                      />
                      <StarRating rate={4} size={18} />
                    </label>
                  </li>
                  <li>
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input
                        name="rating"
                        type="checkbox"
                        value="3"
                        className="h-4 w-4"
                        defaultChecked={checkHandler("rating", "3")}
                        onClick={(e) => handleClick(e.target)}
                      />
                      <StarRating rate={3} size={18} />
                    </label>
                  </li>
                  <li>
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input
                        name="rating"
                        type="checkbox"
                        value="2"
                        className="h-4 w-4"
                        defaultChecked={checkHandler("rating", "2")}
                        onClick={(e) => handleClick(e.target)}
                      />
                      <StarRating rate={2} size={18} />
                    </label>
                  </li>
                  <li>
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input
                        type="checkbox"
                        className="h-4 w-4"
                        name="rating"
                        value="1"
                        defaultChecked={checkHandler("rating", "1")}
                        onClick={(e) => handleClick(e.target)}
                      />
                      <StarRating rate={1} size={18} />
                    </label>
                  </li>
                </ul>
                <div className="m-4">
                  <Button
                    variant="outline"
                    className="w-full"
                    onClick={() => reset("rating")}
                  >
                    Reset
                  </Button>
                </div>
              </AccordionContent>
            </AccordionItem>
          </Accordion>
        </CardContent>
      </Card>
    </>
  );
};

export default Filters;
